import React, { FC } from 'react';
import Icon from '../../../@shared/icon';

type TOverviewCarouselArrowProps = {
  direction: 'previous' | 'next';
  onClick: () => void;
  customClass?: string;
};

const OverviewCarouselArrow: FC<TOverviewCarouselArrowProps> = ({ direction, onClick, customClass = '' }) => {
  const icon = direction === 'previous' ? 'arrow-chevron-left' : 'arrow-chevron-right';

  return (
    <button
      className={'series-overview-carousel__arrow-control series-overview-carousel__arrow-control--' + direction + ' ' + customClass}
      aria-label={direction + 'slide / item'}
      onClick={onClick}
    >
      <Icon iconName={icon} extraClassName="series-overview-carousel__arrow-icons" size={24} />
    </button>
  );
};

export default OverviewCarouselArrow;
